import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VaAddonListComponent } from './addon-list.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { VaPricingModule } from '../pricing/pricing.module';

@NgModule({
  imports: [CommonModule, MatIconModule, MatListModule, MatDividerModule, VaPricingModule],
  declarations: [VaAddonListComponent],
  exports: [VaAddonListComponent],
})
export class VaAddonListModule {}
